/*
 * Longeva reveal — sitewide entrance motion.
 * IntersectionObserver triggers .is-in on first H2/H3 and first <p>
 * of every section once it enters the viewport at 15% threshold.
 * GPU-only (opacity + transform). Respects prefers-reduced-motion.
 */

(() => {
  "use strict";
  const REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (REDUCED) return;

  const tag = (el) => {
    if (!el || el.classList.contains("longeva-reveal-up")) return;
    el.classList.add("longeva-reveal-up");
  };

  const setup = () => {
    document.querySelectorAll("section, [data-section-type]").forEach((section) => {
      const heading = section.querySelector("h1, h2, h3");
      const firstP = section.querySelector("p");
      tag(heading);
      tag(firstP);
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-in");
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
    );

    document.querySelectorAll(".longeva-reveal-up").forEach((el) => observer.observe(el));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setup, { once: true });
  } else {
    setup();
  }
  setTimeout(setup, 800);
})();
